import { css } from '@emotion/css';
import bg1 from "../../assets/bg1.png"
import bg3 from "../../assets/bg3.png"

export const carouselContainer = css`
  
  font-size: 18px;
  font-family: "Source Sans Pro", sans-serif;
  max-width: 500px;
  margin-left:5vw;
  margin-right:5vw;
  behavior: smooth;
  scroll-behavior: smooth;
  background-image: url(${bg1});
  background-repeat: no-repeat;
  background-size: 100%;

  .d-block w-100:hover{
    width:10px;
  }
  
`;